import { render, staticRenderFns } from "./Password.vue?vue&type=template&id=07afe96c&scoped=true"
import script from "./Password.vue?vue&type=script&lang=ts"
export * from "./Password.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07afe96c",
  null
  
)

export default component.exports